// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__bPEGs","requiredAsterisk":"Info_requiredAsterisk__3OgXb"};